import { http } from './base/http';
import type { InvitationResponse } from './types/invitation';

export const InvitationAPIs = {
    async getInvitations(): Promise<InvitationResponse> {
        return http.get<InvitationResponse>('/invitations');
    },

    async createInvitation(email: string, type: string): Promise<void> {
        return http.post('/invitations', { email, user_type: type });
    },
    async updateInvitationType(invitationId: number, type: string): Promise<void> {
        return http.patch(`/invitations/${invitationId}`, { user_type: type });
    },
    async deleteInvitation(invitationId: number): Promise<void> {
        return http.delete(`/invitations/${invitationId}`);
    },
    async resendInvitation(invitationId: number): Promise<void> {
        return http.patch(`/invitations/${invitationId}/resend`, {});
    },
    async validateInviteToken(token: string): Promise<Record<string, unknown>> {
        return await http.get('/invitations/validate', { token });
    },
};
